import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'basic-components';

const EMPTY_ARRAY = [];
const MultiSelect = ({
  value,
  onChange,
  options,
  size = undefined,
  menuPortalTarget = undefined,
  ref,
  ...props
}) => {
  const multiselectDefaultValue = useMemo(() => Array.isArray(value)
    ? value.map(item => ({ label: item, value: item }))
    : value !== "" ? String(value).split(',').map(v => ({ label: v, value: v })) : EMPTY_ARRAY, [value])

  useEffect(() => {
    ref?.current?.dropdown?.current?.setValue(multiselectDefaultValue)
  }, [multiselectDefaultValue, ref])

  return (
    <Dropdown
        {...props}
        defaultValue={multiselectDefaultValue}
        menuPortalTarget={menuPortalTarget || document.body}
        multi
        onChange={onChange}
        options={options}
        placeholder="Select"
        ref={ref}
        size={size}
        withSelectAll
    />
  )
}

MultiSelect.displayName = "MultiSelect"

MultiSelect.propTypes = {
  menuPortalTarget: PropTypes.any,
  name: PropTypes.string.isRequired, 
  onChange: PropTypes.func.isRequired,
  options: PropTypes.any.isRequired, 
  size: PropTypes.string,
  value: PropTypes.any.isRequired
}

export default MultiSelect
